var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 1200,
    viewBox: "0 0 1200 1200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 1200,
    rx: 600,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232 565.587C232 358.708 399.893 191 607 191C814.23 191 982 359.998 982 566.753C982 774.802 813.18 944.856 604.656 944.856H232V565.587ZM607 247.188C430.959 247.188 288.25 389.74 288.25 565.587V888.668H604.656C781.868 888.668 925.75 744.016 925.75 566.753C925.75 390.784 782.918 247.188 607 247.188Z",
    fill: "#D5FF29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M481.989 704.771C464.508 704.504 449.066 700.807 435.663 693.68C422.264 686.355 411.784 676.504 404.224 664.126C396.664 651.749 393.005 637.651 393.247 621.832L395.201 494L449.135 494.824L447.222 619.987C447.055 630.862 450.394 639.912 457.238 647.137C464.082 654.361 472.57 658.051 482.701 658.206C493.23 658.367 502.124 654.943 509.385 647.934C516.645 640.925 520.358 631.983 520.524 621.108L522.438 495.945L575.18 496.751L573.226 624.583C572.984 640.402 568.896 654.381 560.961 666.522C553.026 678.663 542.151 688.188 528.335 695.096C514.721 701.811 499.272 705.035 481.989 704.771Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M607.67 599.779C607.54 579.479 610.729 561.465 617.239 545.737C623.937 530.007 633.112 517.606 644.763 508.535C656.414 499.463 669.794 494.879 684.902 494.782L806.996 494L807.397 556.629L687.853 557.395C677.466 557.462 668.899 561.554 662.152 569.671C655.405 577.789 652.069 587.73 652.145 599.494C652.223 611.72 655.688 621.964 662.54 630.225C669.392 638.486 678.011 642.583 688.398 642.516L807.943 641.75L808.335 702.996L686.241 703.778C671.133 703.875 657.695 699.462 645.929 690.541C634.162 681.619 624.829 669.222 617.928 653.349C611.218 637.705 607.798 619.848 607.67 599.779Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUcLogo);
export default __webpack_public_path__ + "static/media/uc-logo.070db0d1.svg";
export { ForwardRef as ReactComponent };